let intinalState =  {
    loading: 'initial',
    error: false,
    responseType: '', 
    responseDesc:[],       
    message: '',
    data: {},
     
}
export default (
    state = intinalState, action) => {
    switch (action.type) {

        case 'SEND_RECORD_DATA_TO_BACKEND':
            return {
                ...state,
                loading: false,
                responseType:action.payload.data.responseType,
                responseDesc:action.payload.data.responseDesc,
                data:action.payload.data.responseData
            };
        case 'SEND_RECORD_DATA_TO_BACKEND_FAILED':
             return{
                ...state,
                loading: false,
                responseType:action.payload.data.responseType,
                responseDesc:action.payload.data.responseDesc,
                data:action.payload.data.responseData
             };
        case 'RESET_SEND_RECORD_DATA_TO_BACKEND':
               return {...intinalState, loading: 'initial'};    
        case 'SET_SEND_RECORD_DATA_TO_BACKEND_STATUS':
                return {
                    ...state,
                    loading:true,
                };           
        
        case 'DELETE_PROPERTY':
            return {
                loading: false,
                responseType:action.payload.data.responseType,
                responseDesc:action.payload.data.responseDesc,
            }
        default:
            return state;

    }

};